// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3ChgA","additionalInfo":"AgreementModal_additionalInfo__PjZ6O"};